import styled from "styled-components";
import React from "react";

const FooterWrapper = styled.div`
  background: black;
  color: white;
`;

const ContactLegal = styled.div`
  padding: 40px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background: rgb(18, 18, 18);
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

const Copyright = styled.div`
  padding: 10px;
  text-align: center;
  font-size: 12px;
  color: #f7f7f7;
  font-weight: 300;
`;

const LeftHalf = styled.span`
  width: 29%;
  padding-left: 20px;
  padding-right: 70px;
  @media only screen and (max-width: 1000px) {
    padding: 20px;
    padding-bottom: 0px;
    width: auto;
  }
`;

const RightHalf = styled.span`
  padding-left: 100px;
  display: flex;
  width: 69%;
  flex-direction: row;
  flex-wrap: wrap;
  @media only screen and (max-width: 1000px) {
    padding: 20px;
    padding-left: 40px;
    width: auto;
    flex-direction: column;
  }
`;

const Social = styled.img`
  margin: 10px;
  height: 30px;
`;

const Half = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 1000px) {
    width: 100%;
    padding-top: 30px;
  }
`;

const Footer = () => (
  <FooterWrapper>
    <ContactLegal>
      <LeftHalf>
        <a style={{ fontSize: "30px" }}>
          <div style={{ fontSize: "30px", paddingLeft: "20px", paddingTop: "5px" }}>
            <img style={{ height: "30px" }} src="/GigIndiaLogo.svg" />
          </div>
        </a>
        <div style={{ paddingTop: "10px", paddingLeft: "20px" }}>
          We help companies scale faster with our on-demand curated workforce across India.
        </div>
        <div style={{ paddingTop: "20px", paddingLeft: "10px" }}>
          <a href="https://www.facebook.com/gigindia.in/">
            <Social src="/facebook.svg" />
          </a>
          <a href="https://www.instagram.com/gigindia.in/">
            <Social src="/instagram.svg" />
          </a>
          <a href="https://twitter.com/gig_india">
            <Social src="/twitter.svg" />
          </a>
          <a href="https://www.linkedin.com/company/gigindia/">
            <Social src="/linkedin.svg" />
          </a>
          <a href="https://www.youtube.com/channel/UC_PzK6Kdmw8CChaSea1h3Xg">
            <Social src="/youtube.svg" />
          </a>
        </div>
      </LeftHalf>
      <img
        className="hide-on-med-and-down"
        style={{ paddingTop: "50px", width: "5px", height: "200px" }}
        src="/divider.svg"
      />
      <RightHalf>
        <Half>
          <div style={{ width: "50%" }}>
            <div style={{ fontWeight: "600", paddingBottom: "10px" }}>Solutions</div>
            <a style={{ color: "white", fontWeight: "300" }} href="/freelancer">
              <div>For Freelancers</div>
            </a>
            <a style={{ color: "white", fontWeight: "300" }} href="/business">
              <div>For Businesses</div>
            </a>
          </div>
          <div style={{ width: "50%" }}>
            <div style={{ fontWeight: "600", paddingBottom: "10px" }}>Company</div>
            <a style={{ color: "white", fontWeight: "300" }} href="/company">
              <div>About Us</div>{" "}
            </a>
            <a style={{ color: "white", fontWeight: "300" }} href="/customers">
              <div>Customers</div>
            </a>
            <a style={{ color: "white", fontWeight: "300" }} href="/company#press">
              <div>Press</div>
            </a>
          </div>
        </Half>
        <Half>
          <div style={{ width: "50%" }}>
            <div style={{ fontWeight: "600", paddingBottom: "10px" }}>Legal</div>
            <a href="/privacy" style={{ color: "white", fontWeight: "300", fontWeight: "300" }}>
              Privacy
            </a>
          </div>
          <div style={{ width: "50%" }}>
            <div style={{ fontWeight: "600", paddingBottom: "10px" }}>Get in Touch</div>
            <a style={{ color: "white", fontWeight: "300" }} href="/contact">
              <div>Contact Us</div>
            </a>
          </div>
        </Half>
      </RightHalf>
    </ContactLegal>
    <Copyright>Copyright 2019 - Explorium Innovative Technologies Private Limited.</Copyright>
  </FooterWrapper>
);

export default Footer;
